'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('account-not-active', {
      url: '/account-not-active',
      template: '<account-not-active></account-not-active>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/account-not-active/account-not-active.routes.js